export default {"src":"/_next/static/media/shipping-expense.7921b74b.svg","height":33,"width":33};